export default "__VITE_PUBLIC_ASSET__25ef50eb__"